import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class NoDatesModalError extends Component {
	render() { 
		return ( 
			<div>
		  		<Modal isOpen={this.props.isShowModal} toggle={this.props.toggleModal}>
		          	<ModalHeader>{strings.title}</ModalHeader>
		          	<ModalBody>
                        <p dangerouslySetInnerHTML={{
							__html: strings.description
						}}/>
		          	</ModalBody>
		          	<ModalFooter className="text-center">
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-1"
							onClick={this.props.toggleModal}
						>
							<span>{strings.ok}</span>
						</button>
		          	</ModalFooter>
		        </Modal>
			</div>
		)
	}
}

NoDatesModalError.propTypes = {
    isShowModal: PropTypes.bool,
	toggleModal: PropTypes.func,
}
 
export default NoDatesModalError;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/NoDatesModalError/NoDatesModalError.js